<script setup lang="ts">
import {
  Chat,
  InfoCircle,
  QuestionCirlce,
  WhatsApp,
  Website,
} from "@/components/icons";
import { useAppSettingsStore } from "@/stores/appSettingsStore";
import { storeToRefs } from "pinia";
import FaqDialog from "./FaqDialog.vue";
import ContactFormDialog from "./ContactFormDialog.vue";
import { config } from "@/lib/variantConfig.ts";
import {
  DialogRoot,
  DialogTrigger,
  PopoverAnchor,
  PopoverContent,
  PopoverPortal,
  PopoverRoot,
  PopoverTrigger,
  Separator,
} from "reka-ui";
import DialogContent from "../DialogContent.vue";
import ThemeSelect from "./ThemeSelect.vue";

const store = useAppSettingsStore();
const { settings } = storeToRefs(store);
</script>

<template>
  <PopoverRoot>
    <PopoverAnchor>
      <PopoverTrigger class="sidebar-item-secondary">
        <InfoCircle size="28" /><span>{{ $t("menu.help") }}</span>
      </PopoverTrigger>
    </PopoverAnchor>
    <PopoverPortal>
      <PopoverContent
        class="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 min-w-58 z-40"
        align="start"
        :sideOffset="5"
      >
        <div
          class="bg-background-primary rounded-xl border border-border-primary shadow-card"
        >
          <ul>
            <li>
              <DialogRoot>
                <DialogTrigger class="help-item">
                  <QuestionCirlce />
                  <span>{{ $t("help_menu.faq") }}</span>
                </DialogTrigger>
                <DialogContent size="lg">
                  <FaqDialog />
                </DialogContent>
              </DialogRoot>
            </li>
            <Separator class="bg-border-primary h-px mx-4" />
            <li>
              <DialogRoot v-slot="{ close }">
                <DialogTrigger class="help-item">
                  <Chat />
                  <span>{{ $t("help_menu.contact_form") }}</span>
                </DialogTrigger>
                <DialogContent size="lg">
                  <ContactFormDialog @close="close" />
                </DialogContent>
              </DialogRoot>
            </li>
            <Separator class="bg-border-primary h-px mx-4" />
            <template v-if="settings?.contact_whatsapp">
              <li>
                <a
                  class="help-item"
                  :href="`https://wa.me/${settings.contact_whatsapp.replace(
                    /[^0-9]/g,
                    ''
                  )}`"
                >
                  <WhatsApp />
                  <span>WhatsApp</span>
                </a>
              </li>
              <Separator class="bg-border-primary h-px mx-4" />
            </template>
            <li>
              <a
                class="help-item"
                :href="config.links.website_url"
                target="_blank"
              >
                <Website />
                <span>Website</span>
              </a>
            </li>
            <Separator class="bg-border-primary h-px mx-4" />
            <li>
              <ThemeSelect />
            </li>
          </ul>
        </div>
      </PopoverContent>
    </PopoverPortal>
  </PopoverRoot>
</template>
